module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAOdEVYdFNvZnR3YXJlAEZpZ21hnrGWYwAAAQtJREFUeAHtls0NgkAQhWeUAiyBEmyBEiyBm+HEyfhzkAtq4smL8WYJloAlWAIlWIAwLpoYQjCZXR43voTDkp28L8zsBqKBAQvi5d4nMKzdGC3SLZMkpiQXj2bn3eZBAEbajd/wCvH5JVm0TqcEQC1gDO611QQloRYoeBwSc05gCfUMVMzNEI6lzEjEr71+iseB60xYCfQhYS2AlnASQEo4C6AkOgkgJPT3wB8uh1Ve8ChoOaJXTX1ngR/SWCu/bWeBTwtK0wJqtKDkUFPffQjbwsX0/9jzECLCnQVQ4U4CyHBrAXS4lUAf4RXqY+iVxQ0dbiVg7hkfHW4lYP4JT+hwa+IkmVQPDQwAeQP5Qsu6TscudAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/icn_caret_right.png
// module id = nv5a
// module chunks = 1